import { reportTypes as subReports } from 'app/common/api/requests/reports/perform'

const subreports = [
  subReports.REPORT_SUBSIDIES_DETAILED,
  subReports.REPORT_SUBSIDIES_GROUPED,
  subReports.REPORT_SUBSIDIES_ACT,
]

const subreportsNonEmpty = [
  subReports.REPORT_SUBSIDIES_DETAILED,
  subReports.REPORT_SUBSIDIES_GROUPED,
  subReports.REPORT_SUBSIDIES_ACT,
]

export const getSubReports = () => {
  return subreports
}

export const getNonEmptySubreports = () => {
  return subreportsNonEmpty
}
